import React from 'react';
import '../styling/contact.css';

const Contact = () => {
  return (
    <div className="contact-form-wrapper">
      <h3>Get in touch</h3>
      <form 
        action="https://formsubmit.co/suevision@virginmedia.com"
        method="POST"
        className="contact-form"
      >
        <label htmlFor="name">Name</label>
        <input type="text" id="name" name="name" required />

        <label htmlFor="email">Email</label>
        <input type="email" id="email" name="email" required />

        <label htmlFor="message">Message</label>
        <textarea id="message" name="message" rows="5" required></textarea>

        <button type="submit">SEND</button>
      </form>
      <div className="substack">
        <h3>News & Updates</h3>
        <a href="https://suemorriswrites.substack.com/" target="_blank" rel="noopener noreferrer">
            Please visit my substack page here</a>
        <p>Subscribe to my substack to recieve regular articles and newsbits by email</p>
      <iframe className="substack-box" src="https://suemorriswrites.substack.com/embed"  title="substack newsletter input" width="480" height="150" frameborder="0" ></iframe>
      </div>
    </div>
 
  );
};

export default Contact;
